module.exports = __webpack_public_path__ + "media/background-login-workoffice.3e4ef62b.mp4";